export default {
  label: {
    insertImage: 'Insertar imagen',
    insertFile: 'Insertar archivo',
    insertLink: 'Insertar enlace de imagen',
    link: 'Enlace',
    cancel: 'Cancelar',
    select: 'Seleccionar',
  },
};
